'use strict';

require('./StickyAlertMiddle-style.scss');

const root = require('bunsen/helpers/windowCheck');
const classNames = require('classnames');

const React = require('react');
const PropTypes = require('prop-types');
const debounce = require('lodash.debounce');
const ContextComponent = require('../../../global/components/ContextComponent');
const CloseIcon = require('dibs-vg/dist/react/close');
const StickyAlert = require('../StickyAlert');

class StickyAlertMiddle extends ContextComponent {
    constructor(props) {
        super(props);

        this._close = this._close.bind(this);
        this._setVisibility = debounce(this._setVisibility, 100);
        this._scrollCallback = this._scrollCallback.bind(this);
        this._breakpoint = null;
        this._stickyAlertPortal = null;

        this.state = {
            isSticky: false,
            isVisible: props.isOpen,
        };
    }

    componentDidMount() {
        const el = root.document.querySelector('.js-nav-utils-wrap');
        if (el) {
            this._breakpoint = el.getBoundingClientRect().height;
        }
        root.addEventListener('scroll', this._scrollCallback);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ isOpen: nextProps.isOpen });
        this._setVisibility(nextProps);
    }

    componentWillUnmount() {
        root.removeEventListener('scroll', this._scrollCallback);
    }

    _close(event) {
        this.setState({ isVisible: false });

        if (event.currentTarget) {
            this.props.onCloseClick();
        } else {
            this.props.onClose();
        }
    }

    _setVisibility({ isOpen }) {
        this.setState({ isVisible: isOpen });
    }

    _scrollCallback() {
        const portalBoundingClientRect = this._stickyAlertPortal.getBoundingClientRect();

        if (this._breakpoint && portalBoundingClientRect) {
            const elementPositionTop = portalBoundingClientRect.top;
            const isSticky = elementPositionTop < (this._breakpoint || 0);
            this.setState({ isSticky });
        }
    }

    render() {
        const { isSticky, isVisible } = this.state;
        const { nodeSelector, isOpen, onOpen, onClose } = this.props;
        const wrapperClasses = classNames('sticky-alert-wrapper', {
            'is-sticky': isSticky,
        });

        const classes = classNames('sticky-alert', {
            'is-collapsed': !isVisible,
        });

        return (
            <StickyAlert
                ref={c => {
                    this._stickyAlertPortal = c && c.portal;
                }}
                isOpen={isOpen}
                onOpen={onOpen}
                onClose={onClose}
                nodeSelector={nodeSelector}
            >
                <div className={wrapperClasses}>
                    <div className={classes}>
                        {this.props.children}
                        <span className="sticky-alert-close" onClick={this._close}>
                            <CloseIcon />
                        </span>
                    </div>
                </div>
            </StickyAlert>
        );
    }
}

StickyAlertMiddle.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    nodeSelector: PropTypes.string,

    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onCloseClick: PropTypes.func.isRequired,
};

StickyAlertMiddle.defaultProps = {
    nodeSelector: '.js-notification-container-middle',
    onOpen() {},
    onClose() {},
    onCloseClick() {},
};

module.exports = StickyAlertMiddle;



// WEBPACK FOOTER //
// ./assets/js/components/StickyAlert/StickyAlertMiddle/StickyAlertMiddle.jsx